<template>
  <div ref="inputWrapper" class="wrapper">
    <div v-if="!input.isEditable" @click.prevent="onEditableClick">
      <span
        class="editable-click editable-unsaved"
      >
        {{input.ownValue}}
      </span>
      <div
        class="remove-button"
        @click.stop="removeItem"
        :class="{ 'disable-remove': isLast }"
      >
        <i class="fa fa-trash"></i>
      </div>
    </div>
    <div v-else>
      <input type="text" class="edit-input form-control" v-model="input.ownValue" />
      <div
          class="editable-buttons"
        >
          <button
            class="btn btn-primary waves-effect waves-light ok-button"
            @click.prevent="onAccept"
          >
            <i class="mdi mdi-check" />
          </button>
          <button
            class="btn editable-cancel waves-effect waves-light cancel-button"
            @click.prevent="onCancel"
          >
            <i class="mdi mdi-close" />
          </button>
      </div>

    </div>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'edit-input-component',
  props: {
    column: Boolean,
    formatValue: Function,
    value: String,
    isLast: Boolean,
  },

  data() {
    return {
      input: {
        ownValue: '',
        isEditable: true,
      },
    };
  },

  methods: {
    removeItem() {
      if (this.isLast) {
        return;
      }

      this.$emit('remove', this.value);
    },

    onValueChange(newVal) {
      this.input.ownValue = newVal;
    },

    onAccept() {
      this.$emit('change', _.cloneDeep(this.input.ownValue));
      this.$emit('input', _.cloneDeep(this.input.ownValue));

      this.input.isEditable = false;

      document.removeEventListener('click', this.blurHandler);
    },

    onCancel() {
      this.input.isEditable = false;
      this.input.ownValue = _.cloneDeep(this.value);

      document.removeEventListener('click', this.blurHandler);
      this.$emit('cancel', this.input.ownValue);
    },

    onEditableClick() {
      this.enableEdit();
    },

    blurHandler(event) {
      const el = event.target;
      if (el instanceof HTMLElement && !this.$refs.inputWrapper.contains(el)) {
        this.onCancel();
        document.removeEventListener('click', this.blurHandler);
      }
    },

    enableEdit() {
      this.input.isEditable = true;
      setTimeout(() => {
        document.addEventListener('click', this.blurHandler);
      }, 0);
    },
  },

  mounted() {
    this.input.ownValue = _.cloneDeep(this.value);

    this.input.isEditable = false;
  },

  beforeDestroy() {
    document.removeEventListener('click', this.blurHandler);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.editable-input-wrapper {
  display: flex;
}

.edit-input {
  max-width: calc(100% - 100px);
  position: relative;
}

.edit-input input {
  width: 100%;
}

.editable-click {
  text-decoration: none;
  border-bottom: dashed 1px #08c;
  color: #337ab7;
  line-height: 34px;
  cursor: pointer;
  word-wrap: break-word;
}

.remove-button {
  padding-top: 6px;
  float: right;
  cursor: pointer;
}

.disable-remove {
  color: #868e96;
}

.editable-buttons {
  display: inline-block;
  position: relative;
  right: -10px;
}

.edit-input {
  width: calc(100% - 105px);
}

.wrapper {
  width: calc(100% - 10px);
}
</style>



// WEBPACK FOOTER //
// src/modals/FieldAndQuery/components/EditableInput.vue